import React from "react";
import PatientList from "../Patient/PatientList";

const MembersList = () => {
  return (
    <div>
      <PatientList isMember={true} />
    </div>
  );
};

export default MembersList;
